import React from 'react'
import { Card } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'

const CaptableManagementCardSkeleton = () => {
    return (
        <Card className='w-48 w-md-100 p-4 bg-white'>
            <div className='d-flex flex-column align-items-start'>
                <Skeleton
                    width={86}
                    height={43}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
                <Skeleton
                    width={139}
                    height={21}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                />
            </div>
        </Card>
    )
}

export default CaptableManagementCardSkeleton
